import { Navigate } from "react-router-dom";
import { useCurrentOrg } from "../features/user/hooks/userHooks";
import { getHomePagePath } from "../utils/routeUtils";
import useAuth from "../hooks/useAuth";

function NavigateToUserHome() {
  const currentOrg = useCurrentOrg();
  const auth = useAuth();

  return <Navigate to={getHomePagePath(auth.isAuthenticated, currentOrg)} />;
}

export default NavigateToUserHome;
